import MuiExpansionPanel from '@mui/material/Accordion';
import MuiExpansionPanelDetails from '@mui/material/AccordionDetails';
import MuiExpansionPanelSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { withStyles } from 'tss-react/mui';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

const Accordion = withStyles(
  MuiExpansionPanel,
  (_theme, _params, classes) => ({
    root: {
      border: '1px solid rgba(0, 0, 0, .125)',
      boxShadow: 'none',
      '&:not(:last-child)': {
        borderBottom: 0,
      },
      '&:before': {
        display: 'none',
      },
      [`&.${classes.expanded}`]: {
        margin: 'auto',
      },
    },
    expanded: {},
  }),
  { name: 'FaqAccordion' },
);

const AccordionSummary = withStyles(
  props => <MuiExpansionPanelSummary {...props} />,
  (_theme, _params, classes) => ({
    root: {
      backgroundColor: 'rgba(0,0,0,.03)',
      borderBottom: '1px solid rgba(0,0,0,.125)',
      marginBottom: -1,
      minHeight: 56,
      [`&.${classes.expanded}`]: {
        minHeight: 56,
      },
    },
    content: {
      [`&.${classes.expanded}`]: {
        margin: '12px 0',
      },
    },
    expanded: {},
  }),
  { name: 'FaqAccordionSummary' },
);

AccordionSummary.muiName = 'AccordionSummary';

const AccordionDetails = withStyles(
  MuiExpansionPanelDetails,
  theme => ({
    root: {
      padding: theme.spacing(2),
    },
  }),
  { name: 'FaqAccordionDetails' },
);

class FaqItem extends Component {
  state = {
    expanded: false,
  };

  handleChange = () => {
    this.setState(prevState => ({
      expanded: !prevState.expanded,
    }));
  };

  render() {
    const { expanded } = this.state;

    return (
      <Accordion square expanded={expanded} onChange={this.handleChange}>
        <AccordionSummary>
          <Typography variant="strong">{this.props.title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div
            className="highlightLinks"
            dangerouslySetInnerHTML={{
              __html: this.props.content,
            }}
          />
        </AccordionDetails>
      </Accordion>
    );
  }
}

FaqItem.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};

export default FaqItem;
